import { IconArrowLeft } from "@tabler/icons-react";
import FullLoader from "components/loader/full-loader";
import { useInvoiceCreate } from "contexts/v1/pages/InvoiceCreateContext";
import { useNavigate } from "react-router-dom";
import { URLS } from "utils/constants";

const { default: LayoutDashboard } = require("layouts/layout-dashboard-collapse");
const { default: InvoicePreview } = require("./components/invoice-preview");

const InvoiceViewPage = () => {
    const { invoice } = useInvoiceCreate();
    const navigate = useNavigate();

    if (invoice.loading) {
        return (<FullLoader />);
    }

    return (
        <LayoutDashboard>
            <div className="container pb-4">
                {/* Breadcrumb */}
                <div className="d-flex justify-content-between align-items-center py-3">
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        {/* Title Dashboard dengan border-right */}
                        <h2 className="m-0 me-3 fs-2 border-0 pe-3">Invoice Preview</h2>

                        <div className="d-flex">
                            <button className="btn btn-secondary me-2" onClick={() => {
                                navigate(URLS.v1.INVOICES);
                            }}>
                                <IconArrowLeft className="me-2" size={18} /> Back
                            </button>
                        </div>
                    </div>
                </div>
                <InvoicePreview invoice={invoice} className={"a4-size"} />
            </div>
        </LayoutDashboard>
    );
};

export default InvoiceViewPage;